
export { MinRetentionRuleFrequencyEnum } from "/codebuild/output/src3195129928/src/actions-runner/_work/eon-service/eon-service/frontend/packages/api-gw-sdk/dist/models/MinRetentionRule.js"